/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/pat/PatPanel.Props" />
import { ServiceEndpoint } from "Wit/Clients/DistributedTask/Contracts/TaskAgent";
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { IBasePanelContentProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props";

export interface IPatPanelProps extends IBasePanelContentProps {
    /**
     * List of existing connections
     */
    existingServiceConnections: ExternalConnection[];

    /**
     * Callback where the connection is created
     */
    onConnectionCreated: (serviceEndpoint: ServiceEndpoint) => void;
}
